<h1 class="page-title">Plántált gyülekezeteink</h1>

<h2>Karád</h2>

<p>
  2004 óta járunk minden héten Andocsra és Karádra Kaposvárról egy csapattal. Itt kialakult egy kis közösség. Eleinte
  10-15 személyből állt, most 30-40-en vagyunk. A közösség 98%-át cigány származású helyi lakosok alkotják. Karádon
  minden csütörtökön tartunk Istentiszteleti alkalmat.
</p>

<p>
  Ezen kívül ruhaosztásokat, adományozásokat, családi napokat, koncerteket, filmvetítést szervezünk. Keressük az emberek
  valós szükségleteit, és igyekszünk választ adni a nagy kérdéseikre.
</p>

<p>
  Jó látni az Úr vezetését ezeknek a drága embereknek az életében, ahogy Isten felelősségteljes, döntéseket hozó,
  jellemes emberekké formálja őket.
</p>

<p>
  Célunk még sok települést elérni az örömhírrel, hiszen az emberek fáradtak, terheltek, és elcsüggedtek. Akik elhiszik,
  amit Isten üzen nekik, új életet kapnak, és újult erővel vághatnak bele a mindennapokba.
</p>



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/what-we-do/planted-churches/planted-churches.component.html